import React, { useState, useEffect } from "react";
import { http } from "../helper";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import CommonAlert from "../common/Commonalert";
import { BaseUrl } from "../common/config";
import Loader from "../common/loader";
import { useTranslation } from "react-i18next";

const ResetPassword = () => {
  const { t } = useTranslation();
  const queryParameters = window.location.pathname.split("/");
  const [newpassword, setNewPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [loginStatus, setLoginStatus] = useState("");
  const [loginMessage, setLoginMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [token] = useState(queryParameters[2]);
  const [userId] = useState(queryParameters[3]);
  const [alertPopup, setAlertPopup] = useState(false);
  const [tokenexpiry, setTokenExpiry] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const [errmessage, setErrmessage] = useState({});
  const [errmsg, setErrmsg] = useState({});
  const [criteria, setCriteria] = useState({
    length: false,
    upperCase: false,
    lowerCase: false,
    number: false,
    specialChar: false,
  });
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    resetPassword();
  }, []);

  const validatePassword = (password) => {
    const lengthCriteria = /.{8,}/;
    const upperCaseCriteria = /[A-Z]/;
    const lowerCaseCriteria = /[a-z]/;
    const numberCriteria = /[0-9]/;
    const specialCharacterCriteria = /[!@#$%^&*(),.?":{}|<>_\[\]-]/;
    const updatedCriteria = {
      length: lengthCriteria.test(password),
      upperCase: upperCaseCriteria.test(password),
      lowerCase: lowerCaseCriteria.test(password),
      number: numberCriteria.test(password),
      specialChar: specialCharacterCriteria.test(password),
    };
    setCriteria(updatedCriteria);
    let message = t("password_must_include") + ": ";
    let isValid = true;
    if (!updatedCriteria.length) {
      message += t("password_criteria_min_length") + ", ";
      isValid = false;
    }
    if (!updatedCriteria.upperCase) {
      message += t("password_criteria_uppercase") + ", ";
      isValid = false;
    }
    if (!updatedCriteria.lowerCase) {
      message += t("password_criteria_lowercase") + ", ";
      isValid = false;
    }
    if (!updatedCriteria.number) {
      message += t("password_criteria_number") + ", ";
      isValid = false;
    }
    if (!updatedCriteria.specialChar) {
      message += t("password_criteria_special_char") + ", ";
      isValid = false;
    }
    if (isValid) {
      setValidationMessage(t("password_strong_msg"));
    } else {
      setValidationMessage(message.slice(0, -2) + ".");
    }
    return isValid;
  };

  const resetPassword = () => {
    const URL = BaseUrl + "admin/passwordtokencheck";
    const payload = {
      userId,
      token,
    };
    http
      .post(URL, payload)
      .then((response) => {
        if (response.data.success === true) {
          setTokenExpiry(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.response?.status === 400) {
          setTokenExpiry(true);
        }
        setIsLoading(false);
      });
  };

  const handleNewPassword = (event) => {
    const value = event.target.value;
    setNewPassword(value);
    validatePassword(value.replace(/\s+/g, ""));
    setLoginStatus("");
    setLoginMessage("");
    setAlertPopup(false);
    setErrmessage((prev) => ({
      ...prev,
      npassworderr: "",
    }));
    setErrmsg({});
  };

  const handleConfirmPassword = (event) => {
    setConfirmPassword(event.target.value);
    setLoginStatus("");
    setLoginMessage("");
    setAlertPopup(false);
    setErrmessage((prev) => ({
      ...prev,
      cnpassworderr: "",
    }));
    setErrmsg({});
  };

  const handlePasswordFocus = () => {
    setPasswordFocused(true);
  };

  const handlePasswordBlur = () => {
    setPasswordFocused(false);
  };

  const formvalidation = () => {
    const errors = {};
    const errorFlags = {};
    let isValid = true;
    if (newpassword === "") {
      errors.npassworderr = t("newpassword_required_errmsg");
      errorFlags.npass = true;
      isValid = false;
    } else {
      const validPassword = validatePassword(newpassword);
      if (!validPassword) {
        setPasswordFocused(true);
        errorFlags.npass = true;
        isValid = false;
      }
    }
    if (confirmpassword === "") {
      errors.cnpassworderr = t("confirm_newpassword_errmsg");
      errorFlags.cnpass = true;
      isValid = false;
    }
    if (
      confirmpassword !== "" &&
      confirmpassword !== newpassword
    ) {
      errors.cnpassworderr =
        t("password_notmatch_errmsg");
      errorFlags.cnpass = true;
      isValid = false;
    }
    setErrmessage(errors);
    setErrmsg(errorFlags);
    return isValid;
  };

  const resetOnSubmit = (event) => {
    event.preventDefault();
    const isValid = formvalidation();
    if (!isValid) return;
    setAlertPopup(false);
    const URL = BaseUrl + "admin/resetpassword";
    const payload = {
      userId,
      token,
      password: confirmpassword,
    };
    setIsLoading(true);
    http
      .post(URL, payload)
      .then((response) => {
        if (response.data.success === true) {
          setAlertPopup(true);
          setLoginMessage(t("password_reset_msg"));
        }
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.response?.status === 400) {
          setLoginMessage(error.response.data.message);
          setAlertPopup(true);
        }
        setIsLoading(false);
      });
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  return (
    <>
      {alertPopup && (
        <CommonAlert
          title={t("alert_txt")}
          message={loginMessage}
        />
      )}
      <div className="login-page">
        <Header />
        {!isLoading && tokenexpiry ? (
          <div className="container">
            <div className="reset-pass-container">
              <h2>{t("reset_link_expire_txt")}</h2>
              <div className="reset-pass-tokenerr">
                <p>
                  <i className="fa fa-exclamation-triangle"></i>
                  {" "}{t("reset_link_msgtxt")}
                </p>
              </div>
              <div className="back-to-cat">
                <a className="back-btn" href="/">
                  <i className="fa fa-arrow-left"></i>
                  {" "}{t("back_to_home_txt")}
                </a>
              </div>
            </div>
          </div>
        ) : (
          !isLoading && (
            <div className="login">
              <div className="form">
                <form
                  className="login-form"
                  onSubmit={resetOnSubmit}
                >
                  <h2>{t("reset_pass_lbl")}</h2>
                  {loginStatus === 401 && (
                    <p className="err-msg">{loginMessage}</p>
                  )}
                  <div className="input-field col-1">
                    <input
                      type={
                        showNewPassword
                          ? "text"
                          : "password"
                      }
                      value={newpassword}
                      placeholder={t("new_password_txt")}
                      onChange={handleNewPassword}
                      onFocus={handlePasswordFocus}
                      onBlur={handlePasswordBlur}
                    />
                    {errmsg.npass && (
                      <div className="error-msg">
                        {errmessage.npassworderr}
                      </div>
                    )}
                    {passwordFocused && newpassword && (
                      <div className="chg-pwd-lgd">
                        <ul className="chg-pwd-list">
                          <li
                            className={
                              criteria.length
                                ? "checked"
                                : "unchecked"
                            }
                          >
                            {t("password_criteria.length")}
                          </li>
                          <li
                            className={
                              criteria.upperCase
                                ? "checked"
                                : "unchecked"
                            }
                          >
                            {t("password_criteria.upperCase")}
                          </li>
                          <li
                            className={
                              criteria.lowerCase
                                ? "checked"
                                : "unchecked"
                            }
                          >
                            {t("password_criteria.lowerCase")}
                          </li>
                          <li
                            className={
                              criteria.number
                                ? "checked"
                                : "unchecked"
                            }
                          >
                            {t("password_criteria.number")}
                          </li>
                          <li
                            className={
                              criteria.specialChar
                                ? "checked"
                                : "unchecked"
                            }
                          >
                            {t("password_criteria.specialChar")}
                          </li>
                        </ul>
                      </div>
                    )}
                    <span
                      className="icon-eye"
                      onClick={toggleNewPasswordVisibility}
                    >
                      <i
                        className={`fa ${
                          showNewPassword
                            ? "fa-eye-slash"
                            : "fa-eye"
                        }`}
                      ></i>
                    </span>
                  </div>
                  <div className="input-field col-1">
                    <input
                      type={
                        showConfirmPassword
                          ? "text"
                          : "password"
                      }
                      value={confirmpassword}
                      placeholder={t("confirm_password_txt")}
                      onChange={handleConfirmPassword}
                    />
                    {errmsg.cnpass && (
                      <div className="error-msg">
                        {errmessage.cnpassworderr}
                      </div>
                    )}
                    <span
                      className="icon-eye"
                      onClick={
                        toggleConfirmPasswordVisibility
                      }
                    >
                      <i
                        className={`fa ${
                          showConfirmPassword
                            ? "fa-eye-slash"
                            : "fa-eye"
                        }`}
                      ></i>
                    </span>
                  </div>
                  <button type="submit">
                    {t("submit_txt")}
                  </button>
                </form>
              </div>
            </div>
          )
        )}
        {isLoading && (
          <Loader propsClassName="load-lag" />
        )}
        <Footer />
      </div>
    </>
  );
};

export default ResetPassword;